(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/animation", [], factory);
	else if(typeof exports === 'object')
		exports["animation"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["animation"] = factory();
})(this, function() {
return 